var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { injectIntl } from "@irati/utils/lang";
import AdminSummary from "../AdminSummary";
import AtAGlance from "../AtAGlance";
import { ExtendedBackground, Background, DashboardHeading, FlexGrow } from "./styled";
import { ADMIN_TOUR_PREFIX } from "../../../../tour";
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Banner.prototype.render = function () {
        var _a = this.props, user = _a.user, color = _a.color, textColor = _a.textColor, business = _a.business, formatMessage = _a.formatMessage;
        return (React.createElement(ExtendedBackground, { color: color },
            React.createElement(Background, { color: color, justifyContent: "space-between" },
                React.createElement(Grid, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { md: 3, smHidden: true },
                            React.createElement(DashboardHeading, { "data-tour": ADMIN_TOUR_PREFIX + "-step01", margin: "0", color: textColor }, formatMessage({ id: "admin.dashboard.heading" }))),
                        React.createElement(Col, { md: 9, sm: 12 },
                            React.createElement(FlexGrow, { direction: "row", "data-tour": ADMIN_TOUR_PREFIX + "-step02" },
                                React.createElement(AdminSummary, { user: user }),
                                React.createElement(AtAGlance, { color: color, subdomain: business.subdomain, businessName: business.businessName }))))))));
    };
    return Banner;
}(PureComponent));
export default injectIntl(Banner);
